import React from "react"

interface Props {
    show: boolean
    className?: string
    onClose?: () => void
    children?: React.ReactNode
    dismissible ?: boolean
}

export default function BellringersModal(props: Props) {
    let {className="", onClose, children, show, dismissible=true} = props

    if (!show) return <></>

    function closeOnBackdropClick () {
        if (dismissible && onClose) {
            onClose()
        }
    }

    return (
        <div className={`bellringers-modal ${className}`} role="dialog" aria-modal="true" onClick={closeOnBackdropClick}>
            <div onClick={e => e.stopPropagation()}>
                {children}
            </div>
        </div>
    )
}
